export enum GenericDataDisplayTypeEnum {
    TABLE = "table",
    LIST = "list",
}
